import { CloseOutlined } from '@ant-design/icons'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Button } from 'antd'
import React from 'react'
import { deleteModify } from '../../../service/api'

function RejectWarning({setModifyWarning,expertDataQuery}) {
  const queryClient = useQueryClient()
  const mutation = useMutation(deleteModify,{
    onSuccess:()=>{
      queryClient.invalidateQueries(['expertData'])
    }
  })
  return (
    <section onClick={() => {setModifyWarning(false)} }  className=" p-2 rounded-xl relative duration-75 top-18 left-0 z-[100] bg-white">
    <div className="border-dashed border-2 rounded-lg p-2 font-body  ">
      <div className="absolute top-3 left-4 text-red-600"><CloseOutlined/> </div>
      
    { expertDataQuery?.data?.modifiedExpert?.status === 'REJECTED' ?
    <div className='flex flex-col gap-4'>
      
    <h2 className='text-2xl'>برخی تغییرات شما توسط کارشناسان به دلیل زیر رد شد.</h2>
    <p className='text-base text-red-500 '>{expertDataQuery?.data?.modifiedExpert?.comment?.comment}</p>
    <Button onClick={()=>mutation.mutate()} className='w-1/3 mx-auto'>متوجه شدم</Button>
    </div>
    :
   <p className="p-2 text-xl animate-pulse text-blue-700">
          
          
     تغییرات شما در حال بررسی است و در صورت تایید تا 24 ساعت آینده اعمال خواهد شد.
        </p>}
      
    </div>
  </section>
  )
}

export default RejectWarning